import React from "react";

// Le caractère ❤ s'affiche en emoji sur iOS et Android : il garde alors sa
// propre couleur, ignore `color`, et un cœur perdu ne s'éteint jamais. Un
// tracé suit la couleur du texte partout.
export default function Heart({ className = "" }) {
  return (
    <svg className={`pq-heart ${className}`} viewBox="0 0 24 24" aria-hidden="true">
      <path fill="currentColor" d="M12 21.35 10.55 20C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54z" />
    </svg>
  );
}
